import streak1 from "../images/1_week.png"
import streak2 from "../images/5_weeks.png";
import streak3 from "../images/10_weeks.png";
import streak4 from "../images/25_weeks.png";
import streak5 from "../images/52_weeks.png";

import streak1_locked from "../images/1_week_locked.png"
import streak2_locked from "../images/5_weeks_locked.png";
import streak3_locked from "../images/10_weeks_locked.png";
import streak4_locked from "../images/25_weeks_locked.png";
import streak5_locked from "../images/52_weeks_locked.png";

import joined from "../images/joined.png";
import upvote from "../images/upvote.png";
import foundingFoodie from "../images/founding_foodie.png";
// Legacy 1000 medal asset retained for future reuse.
// import firstThousand from "../images/1000.png";
import wantItThatWay from "../images/Iwant.png";
import theSearcher from "../images/the_searcher.png";

import joined_locked from "../images/joined_locked.png";
import upvote_locked from "../images/upvote_locked.png";
import foundingFoodieLocked from "../images/founding_foodie_locked.png";
// Legacy 1000 locked medal asset retained for future reuse.
// import firstThousand_locked from "../images/1000_locked.png";
import wantItThatWay_locked from "../images/Iwant_locked.png";
import theSearcher_locked from "../images/the_searcher_locked.png";

import category1 from "../images/entree-medal.png";
import category2 from "../images/pizza-medal.png";
import category3 from "../images/burger-medal.png";
import category4 from "../images/handheld-medal.png";
import category5 from "../images/sides-medal.png";
import category6 from "../images/apps-medal.png";
import category7 from "../images/breakfast-medal.png";
import category8 from "../images/dessert-medal.png";
import category9 from "../images/fast_food-medal.png";

import category1_locked from "../images/entree-medal_locked.png";
import category2_locked from "../images/pizza-medal_locked.png";
import category3_locked from "../images/burger-medal_locked.png";
import category4_locked from "../images/handheld-medal_locked.png";
import category5_locked from "../images/sides-medal_locked.png";
import category6_locked from "../images/apps-medal_locked.png";
import category7_locked from "../images/breakfast-medal_locked.png";
import category8_locked from "../images/dessert-medal_locked.png";
import category9_locked from "../images/fast_food-medal_locked.png";

export const JumpStarter: Record<string, string> = {
  "J1": joined,
  "J1_locked": joined_locked,
  "J2" : foundingFoodie,
  "J2_locked" : foundingFoodieLocked,
  // Legacy 1000 medal mapping retained for future reuse.
  // "J2" : firstThousand,
  // "J2_locked" : firstThousand_locked,
  "J3": upvote,
  "J3_locked": upvote_locked,
  "J4": upvote,
  "J4_locked": upvote_locked,
  "J5": upvote,
  "J5_locked": upvote_locked,
  "J6" : theSearcher,
  "J6_locked" : theSearcher_locked,
  "J7" : wantItThatWay,
  "J7_locked" : wantItThatWay_locked
};

export const SupportingTheCommunity: Record<string, string> = {
  "C1" : category1,
  "C1_locked" : category1_locked,
  "C2" : category2,
  "C2_locked" : category2_locked,
  "C3" : category3,
  "C3_locked" : category3_locked,
  "C4" : category4,
  "C4_locked" : category4_locked,
  "C5" : category5,
  "C5_locked" : category5_locked,
  "C6" : category6,
  "C6_locked" : category6_locked,
  "C7" : category7,
  "C7_locked" : category7_locked,
  "C8" : category8,
  "C8_locked" : category8_locked,
  "C9" : category9,
  "C9_locked" : category9_locked
};

export const Streaks: Record<string, string> = {
  "S1" : streak1,
  "S1_locked" : streak1_locked,
  "S2" : streak2,
  "S2_locked" : streak2_locked,
  "S3" : streak3,
  "S3_locked" : streak3_locked,
  "S4" : streak4,
  "S4_locked" : streak4_locked,
  "S5" : streak5,
  "S5_locked" : streak5_locked
}

export function getImage(sectionKey: string, code: string): string {
  if (sectionKey === "jumpstarter") return JumpStarter[code];
  if (sectionKey === "community") return SupportingTheCommunity[code];
  if (sectionKey === "streak") return Streaks[code];
  return "";
}
